/* assets/mlmt-pdp.js — the product-page block scripts, in one cacheable file.

   12 Sep 2026: these ran as inline script blocks inside the custom-liquid blocks
   of templates/product.json, product.moissanite.json and product.pdp2027.json —
   byte-identical in all three, no Liquid in any of them. Order below is the
   template block order, unchanged. Every block guards on its own markup
   (querySelector + return), so a template that drops a block simply skips it.

   Loaded deferred from layout/theme.liquid after theme.js, behind
   request.page_type == 'product'. Deferred = DOM parsed before any of this runs,
   so the readyState branches take their immediate path; DOMContentLoaded and
   load listeners still fire, as they did inline. */

/* ── block custom_T7txHy ── */
// Realistic Countdown Timer to Midnight Local Time
function startVmadCountdown() {
    function updateCountdown() {
        const now = new Date();

        // Calculate next midnight (00:00:00 of next day)
        const tomorrow = new Date(now);
        tomorrow.setDate(tomorrow.getDate() + 1);
        tomorrow.setHours(0, 0, 0, 0);

        // Calculate time difference in milliseconds
        const timeDiff = tomorrow.getTime() - now.getTime();

        if (timeDiff <= 0) {
            // Timer expired - reset for next day
            const timerElement = document.getElementById('vmadCountdownTimer');
            if (timerElement) {
                timerElement.innerHTML = '<span style="color: var(--mlmtInk);">RENEWING...</span>';
                timerElement.classList.add('vmad-expired');
            }

            // Reset after 2 seconds
            setTimeout(() => {
                const timerElement = document.getElementById('vmadCountdownTimer');
                if (timerElement) {
                    timerElement.classList.remove('vmad-expired');
                }
                startVmadCountdown();
            }, 2000);
            return;
        }

        // Convert milliseconds to hours, minutes, seconds
        const hours = Math.floor(timeDiff / (1000 * 60 * 60));
        const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);

        // Update display elements
        const hoursElement = document.getElementById('vmadHours');
        const minutesElement = document.getElementById('vmadMinutes');
        const secondsElement = document.getElementById('vmadSeconds');

        if (hoursElement) hoursElement.textContent = hours.toString().padStart(2, '0');
        if (minutesElement) minutesElement.textContent = minutes.toString().padStart(2, '0');
        if (secondsElement) secondsElement.textContent = seconds.toString().padStart(2, '0');
    }

    // Update immediately
    updateCountdown();

    // Update every second
    const countdownTimer = setInterval(updateCountdown, 1000);

    return countdownTimer;
}

// Start countdown when page loads
document.addEventListener('DOMContentLoaded', startVmadCountdown);

// Also restart if page becomes visible again (handles tab switching)
document.addEventListener('visibilitychange', function() {
    if (!document.hidden) {
        startVmadCountdown();
    }
});

/* ── block mlmt_gallery_grid ── */
(function(){
  var BP = 1024, wrap = null, on = false;

  function group(){
    return document.querySelector('[data-product-single-media-group]')
        || document.querySelector('[data-product-photos]');
  }
  function enter(){
    var el = document.querySelector('[data-product-photos]');
    if(!el || on) return;
    wrap = el.closest('.product__photos') || el.parentNode;
    // Flickity keeps its instance on the element; tear it down cleanly
    try{
      if(window.Flickity && Flickity.data(el)) Flickity.data(el).destroy();
    }catch(e){}
    wrap.classList.add('mlmt-gal-grid');
    on = true;
  }
  function leave(){
    if(!on || !wrap) return;
    wrap.classList.remove('mlmt-gal-grid');
    on = false;
    // let Motion re-init on its own terms
    window.dispatchEvent(new Event('resize'));
  }
  function markVideos(){
    document.querySelectorAll('.mlmt-gal-grid .product-main-slide').forEach(function(sl){
      var v = sl.querySelector('video, iframe, .product__video-wrapper');
      if(!v || sl.classList.contains('mlmt-has-video')) return;
      sl.classList.add('mlmt-has-video');
      var b = document.createElement('span'); b.className = 'mlmt-play';
      sl.appendChild(b);
      sl.addEventListener('click', function(){
        sl.classList.add('mlmt-playing');
        var native = sl.querySelector('video');
        if(native){ native.setAttribute('controls',''); native.play().catch(function(){}); }
      });
    });
  }
  function sync(){
    if(window.innerWidth >= BP){ enter(); markVideos(); } else leave();
  }
  // run after Motion has built the slider
  if(document.readyState === 'complete') setTimeout(sync, 300);
  else window.addEventListener('load', function(){ setTimeout(sync, 300); });
  var t; window.addEventListener('resize', function(){ clearTimeout(t); t = setTimeout(sync, 200); });
})();

/* ── block mlmt_carat_swatch ── */
(function(){
  var host = document.querySelector('[data-mlmt-carat-map]');
  if(!host) return;
  var raw = host.getAttribute('data-mlmt-carat-map') || '';
  if(!raw) return;
  var mm = {};
  raw.split('|').forEach(function(pair){
    var i = pair.lastIndexOf('=');
    if(i > 0) mm[pair.slice(0,i).trim()] = parseFloat(pair.slice(i+1));
  });
  var widths = Object.keys(mm).map(function(k){ return mm[k]; }).filter(function(n){ return n>0; });
  if(!widths.length) return;
  var max = Math.max.apply(null, widths);

  function paint(){
    document.querySelectorAll('.variant-wrapper').forEach(function(w){
      var lab = w.querySelector('.mlmt-vp__k') || w.querySelector('.variant__label');
      if(!lab) return;
      var name = (lab.textContent||'').toLowerCase();
      if(name.indexOf('carat') === -1 && name.indexOf(' ct') === -1) return;
      w.querySelectorAll('.variant-input > label').forEach(function(l){
        if(l.querySelector('.mlmt-ct')) return;
        var t = l.querySelector('.mlmt-vp__t');
        var key = ((t ? t.textContent : l.textContent)||'').trim();
        var v = mm[key];
        if(v === undefined){
          for(var k in mm){ if(key.indexOf(k) === 0 || k.indexOf(key) === 0){ v = mm[k]; break; } }
        }
        if(!v) return;
        // truly proportional: a 4mm stone renders exactly twice a 2mm one.
        // Compressing this would misrepresent the only thing the dot is for.
        var px = Math.max(8, Math.round(26 * (v / max)));
        var s = document.createElement('span');
        s.className = 'mlmt-ct';
        s.innerHTML = '<span class="mlmt-ct__dot" style="width:'+px+'px;height:'+px+'px"></span>'
                    + '<span class="mlmt-ct__mm">'+v+' mm</span>';
        l.appendChild(document.createTextNode(' '));
        l.appendChild(s);
      });
    });
  }
  if(document.readyState !== 'loading') setTimeout(paint, 120);
  else document.addEventListener('DOMContentLoaded', function(){ setTimeout(paint, 120); });
  document.addEventListener('change', function(e){
    if(e.target && e.target.classList && e.target.classList.contains('mlmt-vp__radio')) setTimeout(paint, 60);
  });
})();

/* ── block mlmt_compare_retail ── */
(function(){
  var el = document.querySelector('[data-mlmt-cmpret]');
  if (!el) return;
  var cfg = null;

  function sym(){
    var p = document.querySelector('.product-single__price, [data-product-price], .price-sale, .product-price');
    var m = ((p || {}).textContent || '').match(/[€$£]/);
    if (m) return m[0];
    var code = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    return { EUR:'€', GBP:'£', USD:'$' }[code] || '$';
  }


  function carats(){
    var txt = '';
    var sel = document.querySelector('[class*="mlmt-sel"], .selected-variant');
    if (sel) txt = sel.textContent;
    if (!/ct/i.test(txt)){
      var on = document.querySelector('.variant-input input:checked, [data-index] [aria-checked="true"]');
      txt += ' ' + (document.title || '') + ' ' +
             [].map.call(document.querySelectorAll('.variant-input-wrap label.active, [aria-checked="true"]'),
                         function(n){ return n.textContent; }).join(' ');
    }
    var m = txt.match(/([\d.]+)\s*CT/i);
    return m ? parseFloat(m[1]) : 0;
  }

  function materialText(){
    var s = document.querySelector('.mlmt-card-spec, [data-material-line]');
    return s ? s.textContent.trim() : 'simulated stones';
  }

  function render(value, label, basis){
    if (!value){ el.hidden = true; return; }
    el.querySelector('[data-cr-label]').textContent = label;

    var rounded = Math.round(value / 50) * 50;
    if (rounded <= 0){ el.hidden = true; return; }
    el.querySelector('[data-cr-val]').textContent = sym() + rounded.toLocaleString();
    var b = el.querySelector('[data-cr-basis]');
    b.textContent = basis || '';
    el.hidden = false;
  }

  el.querySelector('.mlmt-cmpret__i').addEventListener('click', function(){
    var b = el.querySelector('[data-cr-basis]');
    b.hidden = !b.hidden;
  });

  function compute(){
    var mf = parseFloat(el.dataset.mf);
    if (isFinite(mf) && mf > 0){
      var fx0 = parseFloat((window.Shopify && Shopify.currency && Shopify.currency.rate) || 1) || 1;
      return render(mf * fx0, 'A natural-diamond version costs about', el.dataset.mfbasis);
    }
    if (!cfg) return;
    var ct = carats();
    if (!ct){ el.hidden = true; return; }
    var fx = parseFloat((window.Shopify && Shopify.currency && Shopify.currency.rate) || 1) || 1;
    var usd = Math.max(cfg.floorUSD || 0, ct * cfg.perCaratUSD);
    var basis = (cfg.basisTemplate || '')
                  .replace('{ct}', ct)
                  .replace('{material}', materialText());
    render(usd * fx, cfg.label, basis);
  }

  fetch(el.dataset.src).then(function(r){ return r.json(); })
    .then(function(j){ cfg = j; compute(); }).catch(function(){});

  document.addEventListener('variant:change', compute);
  document.addEventListener('change', function(e){
    if (e.target.closest && e.target.closest('.variant-wrapper, .variant-input-wrap, select')) setTimeout(compute, 60);
  });
})();

/* ── block mlmt_angara_panels ── */
(function(){
  var b=document.querySelector('[data-mlmt-stone]');
  if(!b) return;
  b.addEventListener('click',function(){
    var body=document.querySelector('[data-mlmt-stone-body]');
    if(!body) return;
    body.hidden=!body.hidden;
    b.textContent=body.hidden?'About this stone':'Close';
  });
})();

/* ── block mlmt_cashback ── */
(function(){
  'use strict';
  var box = document.querySelector('[data-mlmt-cb]');
  if (!box) return;


  /* 12 Sep 2026: the exact variant price, in cents. The buy box prints the
     ceil'd price (€61 for a €60,95 item), so scraping it overstated the
     cashback by the rounding. Order of trust: the variant handed over by the
     last 'variant:change' event (theme.js dispatches it with detail.variant,
     price in cents of the active currency), then the data-cb-price attribute
     the template seeds from the selected variant, then the old text scrape. */
  var EXACT_CENTS = parseInt(box.getAttribute('data-cb-price'), 10) || 0;
  function livePriceCents(){
    if (EXACT_CENTS > 0) return EXACT_CENTS;
    var el = document.querySelector('.price-sale, .product-single__price, [data-product-price]');
    if (!el) return 0;
    var sale = el.querySelector('.price-sale') || el;
    var n = (sale.textContent || '').match(/[\d]+(?:[.,]\d+)?/);
    if (!n) return 0;
    return Math.round(parseFloat(n[0].replace(',', '.')) * 100);
  }
  var PRICE_CENTS = livePriceCents();

  function money(cents){
    /* 12 Sep 2026: exact, with the ' EUR' code the drawer's credit line carries
       — theme.Currency.formatActiveMoneyExact is the JS twin of price-clean's
       exact: true. The older paths stay as the fallback. */
    if (window.theme && theme.Currency && typeof theme.Currency.formatActiveMoneyExact === 'function')
      return theme.Currency.formatActiveMoneyExact(cents);
    if (window.Shopify && Shopify.formatMoney && window.theme && theme.moneyFormat)
      return Shopify.formatMoney(cents, theme.moneyFormat);
    var sym = (document.querySelector('.product-price, [data-product-price]') || {}).textContent || '';
    sym = (sym.match(/[€$£]/) || ['$'])[0];
    return sym + (cents / 100).toFixed(2);
  }

  function bestRate(price){
    /* One resolver for the theme (snippets/mlmt-cashback-rate.liquid): it
       honours the customer-tag gate and the UTC window this copy ignored. */
    if (typeof window.mlmtCashbackRate === 'function') return window.mlmtCashbackRate(price);
    var cfg = window.giftkart_cashback_app_data;
    if (!cfg || !cfg.cashback_campaigns) return 0;
    var active = (window.Shopify && Shopify.currency && Shopify.currency.active) || cfg.currency || 'USD';
    var today  = new Date().toISOString().slice(0, 10);
    var best   = 0;

    cfg.cashback_campaigns.forEach(function(c){
      if (!c.isEnabled || c.isDeleted) return;
      if (c.currency && c.currency !== active) return;

      var s = c.campaignScheduleData || {};
      if (s.campaignSchedule === 'SCHEDULED'){
        if (s.startDate && today < s.startDate) return;
        if (s.endDate   && today > s.endDate)   return;
      }

      var tiers = (c.frontendData && c.frontendData.tiers) || [];
      tiers.forEach(function(t){
        var rules = (t.eligibilityRules && t.eligibilityRules.rulesList) || [];
        var min = 0;
        rules.forEach(function(r){
          var v = r.ruleValue && parseFloat(r.ruleValue.qualifierValue);
          if (isFinite(v)) min = Math.max(min, v);
        });

        if (price >= min){
          var pct = parseFloat(t.cashbackValue);
          if (isFinite(pct) && pct > best) best = pct;
        }
      });
    });
    return best;
  }

  /* ── RATE OVERRIDE ───────────────────────────────────────────────────
     Jordan, 6 Sep: "for now make the cashback on the site back to 10%, bc
     just before rebranding we will put 10% again."

     Everything below this line reads the LIVE GiftKart config, which is the
     correct design and why the block has never carried a hard-coded rate: the
     store runs several campaigns at once and they start and stop, so a fixed
     number is wrong the day a campaign changes.

     This override exists because the app currently pays 5% and the plan is to
     put it back to 10% at launch. It is safe ONLY because this is the
     unpublished draft theme — a customer cannot see it.

     12 Sep 2026: the override moved into the shared resolver
     (snippets/mlmt-cashback-rate.liquid) so the PDP, the drawer, the cart
     page and the explainer all say the same number — this one is 0 and the
     block reads the resolver like every other surface. The publish-day
     switch is the resolver's RATE_OVERRIDE (LAUNCH-CHECKLIST item 6). */
  var RATE_OVERRIDE = 0;

  function paint(){
    PRICE_CENTS = livePriceCents() || PRICE_CENTS;
    var price = PRICE_CENTS / 100;
    if (!price) { box.hidden = true; return; }
    var pct = RATE_OVERRIDE || bestRate(price);
    if (!pct) { box.hidden = true; return; }
    box.querySelector('[data-cb-amt]').textContent = money(Math.round(PRICE_CENTS * pct / 100));
    box.hidden = false;
  }


  var tries = 0;
  (function wait(){
    if (window.giftkart_cashback_app_data || tries++ > 40) return paint();
    setTimeout(wait, 150);
  })();


  var priceHost = document.querySelector('.product-single__price, [data-product-price]');
  if (priceHost){
    var t;
    new MutationObserver(function(){
      clearTimeout(t); t = setTimeout(paint, 120);
    }).observe(priceHost, { childList:true, subtree:true, characterData:true });
  }
  document.addEventListener('variant:change', function(e){
    /* 12 Sep 2026: read the exact price off the event before repainting. */
    var v = e && e.detail && e.detail.variant;
    if (v && isFinite(parseInt(v.price, 10))) EXACT_CENTS = parseInt(v.price, 10);
    paint();
  });
  document.addEventListener('change', function(e){
    if (e.target.closest && e.target.closest('.variant-wrapper, .variant-input-wrap, select')) setTimeout(paint, 150);
  });
})();

/* ── block mlmt_sticky_atc ── */
(function(){
  if (!document.querySelector('[data-mlmt-sticky]')) return;

  /* 18 Sep 2026: the bar is looked up on every pass, never cached. The theme
     editor re-renders the product section — and this bar with it — on every
     setting change; a cached node kept syncing a detached copy while the
     fresh one sat hidden. arm() re-observes the new button on
     shopify:section:load, and the add click is delegated for the same reason. */
  function getBar(){ return document.querySelector('[data-mlmt-sticky]'); }
  var target = null, io = null;

  /* 12 Sep 2026: Motion's own hook first. The text match alone went blind the
     moment updateCartButton (theme.js) rewrote the label to "Sold out" — so on
     an unavailable variant realBtn() returned nothing, the bar kept saying
     "Add to cart", and the tap was a silent no-op. The text match stays as the
     fallback for a form without the hook. */
  function realBtn(){
    var bar = getBar();
    var hooked = [].slice.call(document.querySelectorAll('[data-add-to-cart]'))
      .filter(function(b){ return b.offsetParent && !(bar && bar.contains(b)); })[0];
    if (hooked) return hooked;
    return [].slice.call(document.querySelectorAll('button, input[type="submit"]'))
      .filter(function(b){
        return /add to cart/i.test(b.textContent || b.value || '') && b.offsetParent && !(bar && bar.contains(b));
      })[0];
  }
  function liveTarget(){ return (target && target.isConnected) ? target : realBtn(); }

  /* 12 Sep 2026: the bar's button MIRRORS the real one — disabled state and
     label ("Sold out", "Unavailable") read off the button Motion maintains,
     never guessed. [data-add-to-cart-text] is the label span; the icon and the
     price node are its siblings, so the whole button's text is not the label. */
  function mirror(){
    var bar = getBar(); if (!bar) return;
    var b = liveTarget();
    var st = bar.querySelector('[data-st-add]');
    if (!b || !st) return;
    var label = b.querySelector('[data-add-to-cart-text]');
    var txt = ((label ? label.textContent : (b.textContent || b.value)) || '').replace(/\s+/g,' ').trim();
    /* 18 Sep 2026: the breaker appends " • price" to the real button; the bar prints the price
       in its own slot, so it mirrors the bare label the breaker stored on the node. */
    if (label && label.getAttribute('data-qb-base')) txt = label.getAttribute('data-qb-base');
    else txt = txt.replace(/\s+\u2022.*$/, '');
    st.disabled = !!b.disabled;
    st.textContent = txt || 'Add to cart';
  }

  /* 12 Sep 2026: which qty-breaker tier is checked. Only the picker updates
     [data-product-price]; the breaker's bundle/set tiers never touch it, so
     the bar showed the single price while the click (intercepted by the
     breaker) added the set. data-qb-price carries the tier NAME; the price is
     that node's text. */
  function qbTier(){
    var c = document.querySelector('[data-mlmt-qb] input[name="mlmt-qb"]:checked');
    return c && c.value !== 'single' ? c.value : null;
  }

  function sync(){
    var bar = getBar(); if (!bar) return;
    var priceEl = bar.querySelector('[data-st-price]');
    var was = bar.querySelector('[data-st-was]');
    if (!priceEl) return;
    var num = function(s){ return s ? parseFloat(String(s).replace(/[^\d.,]/g,'').replace(',', '.')) : NaN; };
    var tier = qbTier();

    if (tier){
      var tp = document.querySelector('[data-mlmt-qb] [data-qb-price="' + tier + '"]');
      var tw = document.querySelector('[data-mlmt-qb] [data-qb-was="' + tier + '"]');
      /* no price node for the tier = show nothing rather than the wrong number */
      priceEl.textContent = tp ? (tp.textContent || '').replace(/\s+/g,' ').trim() : '';
      if (was){
        var twt = tw && !tw.hidden ? (tw.textContent || '').trim() : '';
        if (twt && isFinite(num(twt)) && num(twt) > num(priceEl.textContent)){ was.textContent = twt; was.hidden = false; }
        else { was.hidden = true; }
      }
    } else {
      /* 20 Sep 2026: the breaker keeps the single tier's price and compare-at current per
         variant ([data-qb-price="single"] / [data-qb-was="single"], snippets/mlmt-qty-breaker);
         the bar reads those first so its numbers are the breaker's numbers. Motion's price
         nodes are the fallback on a page without the breaker. */
      var sp = document.querySelector('[data-mlmt-qb] [data-qb-price="single"]');
      var sw = document.querySelector('[data-mlmt-qb] [data-qb-was="single"]');
      if (sp && (sp.textContent || '').trim()){
        priceEl.textContent = (sp.textContent || '').replace(/\s+/g,' ').trim();
        if (was){
          var swt = sw && !sw.hidden ? (sw.textContent || '').replace(/\s+/g,' ').trim() : '';
          if (swt && isFinite(num(swt)) && num(swt) > num(priceEl.textContent)){ was.textContent = swt; was.hidden = false; }
          else was.hidden = true;
        }
      } else {
        var p = document.querySelector('[data-product-price]')
             || document.querySelector('.product-single__meta .price-sale, .product-single__meta .sale-price, .product-single__price');
        if (p){
          var m = p.textContent.replace(/\s+/g,' ').match(/[€$£]\s?[\d.,]+/g);
          priceEl.textContent = m ? m[0] : '';
        }
        var cmp = document.querySelector('.product-single__meta .price-original, .product-single__meta .igComparePrice');
        if (was){
          /* a compare-at Motion has hidden (no saving on this variant) is not a saving */
          var cm = (cmp && cmp.offsetParent !== null) ? (cmp.textContent.match(/[€$£]\s?[\d.,]+/) || [])[0] : null;
          var sale = num(priceEl.textContent);
          if (cm && isFinite(num(cm)) && isFinite(sale) && num(cm) > sale){
            was.textContent = cm; was.hidden = false;
          } else { was.hidden = true; }
        }
      }
    }
    mirror();

    /* 20 Sep 2026, Jordan: "the sticky cart button looks like a bracelet for $207 while it's the
       full set." Under the set tier the picture is the SET product's photograph in the chosen
       metal (data-qb-img-<metal> on the tier, from snippets/mlmt-qty-breaker); every other tier
       shows the gallery's current shot as before. */
    var img = bar.querySelector('[data-st-img]');
    var tierEl = tier ? document.querySelector('[data-mlmt-qb] [data-qb-tier="' + tier + '"]') : null;
    var picked = pickedValues();
    var metal = (picked.metal || '').toLowerCase();
    var tierImg = tierEl ? (tierEl.getAttribute('data-qb-img-' + (metal.indexOf('silver') > -1 ? 'silver' : 'gold')) || '') : '';
    if (img && img.tagName === 'IMG'){
      /* 20 Sep 2026, Jordan: "make sure the product image changes if we change variants on
         the sticky bar." The gallery swaps its slides a beat after variant:change, so a bar
         that copied the gallery's first picture kept the old metal. The single tier now takes
         the breaker's own thumbnail — [data-qb-single] [data-qb-thumb], painted per variant
         from the catalogue (the variant's own photograph, the silver hero for silver) — and
         only falls back to the gallery when there is no breaker. */
      var qbThumb = document.querySelector('[data-mlmt-qb] [data-qb-single] [data-qb-thumb]');
      var qbSrc = qbThumb ? (qbThumb.getAttribute('src') || '') : '';
      if (tierImg) img.src = tierImg;
      else if (qbSrc) img.src = qbSrc;
      else {
        var shot = [].slice.call(document.querySelectorAll(
          '.mlmt-gm img, .product-single__media img, .product-image img, .product__media img'
        )).filter(function(i){ return (i.currentSrc || i.getAttribute('src') || '').indexOf('http') === 0; })[0];
        if (shot) img.src = shot.currentSrc || shot.getAttribute('src');
      }
    }

    /* 20 Sep 2026, Jordan: "I don't like the variant swatches, make it clean." The two dropdowns
       the bar carried since 18 Sep are gone; the bar says what is chosen in one quiet line —
       "FULL TENNIS SET · GOLD · 6 CT" — and the button adds exactly that. Choosing happens in
       the page, where the picker and the breaker are. */
    /* 20 Sep 2026, later, Jordan: "in the sticky bar make sure we see the gold swatch colour
       and if we press it, it has the dropdown with silver; same for 6 CT, a dropdown for 10 CT;
       the product image in front; the compare price beside the price — replicate the bundle
       breaker's format." So on the single tier the bar is the breaker's row: thumbnail ·
       [● Gold ▾] · [6 CT ▾] · struck compare-at · price · button. The dropdowns drive the
       real picker (the change handler below clicks the matching radio's label), so Motion's
       variant change runs and the breaker, the gallery and the price all follow. Under a
       bundle or set tier the choosing lives in the breaker's own rows, so the bar says what
       is chosen in one line instead. */
    var vEl = bar.querySelector('[data-st-variant]');
    if (vEl){
      if (tier || !buildPickers(vEl)){
        vEl.classList.remove('mlmt-sticky__pick');
        vEl.removeAttribute('data-st-sig');
        var parts = [];
        var tname = tierEl ? (tierEl.getAttribute('data-qb-tier-name') || '') : '';
        if (tname) parts.push(tname);
        if (picked.metal) parts.push(picked.metal);
        if (picked.carat) parts.push(picked.carat);
        vEl.textContent = parts.join(' \u00b7 ');
      }
    }
  }

  /* the chosen value of each option the shopper can actually choose (2+ values), by kind */
  function pickedValues(){
    var out = { metal: '', carat: '' };
    pickerGroups().forEach(function(g){
      var on = g.inputs.filter(function(i){ return i.checked; })[0];
      if (!on) return;
      var v = (on.value || '').replace(/[\u2B50\uFE0F]/g, '').trim();
      if (g.kind === 'metal' && !out.metal) out.metal = v;
      else if (g.kind === 'pill' && !out.carat) out.carat = v;
    });
    return out;
  }

  function metalTone(v){
    v = (v || '').toLowerCase();
    if (v.indexOf('rose') > -1) return 'linear-gradient(145deg,#F7DCD0 0%,#DFA795 46%,#B0705C 100%)';
    if (v.indexOf('white') > -1 || v.indexOf('silver') > -1 || v.indexOf('platinum') > -1 || v.indexOf('steel') > -1) return 'linear-gradient(145deg,#FFFFFF 0%,#DADDE2 46%,#9AA0A8 100%)';
    if (v.indexOf('black') > -1 || v.indexOf('onyx') > -1) return 'linear-gradient(145deg,#5A5550 0%,#2E2A26 46%,#151311 100%)';
    if (v.indexOf('gold') > -1) return 'linear-gradient(145deg,#F8E9BB 0%,#D9B45C 46%,#A9812F 100%)';
    return 'linear-gradient(145deg,#EDEDED 0%,#CFCFCF 46%,#A8A8A8 100%)';
  }
  /* the main picker's radio groups: {name, kind, inputs[]} for every option with 2+ values */
  function pickerGroups(){
    var radios = [].slice.call(document.querySelectorAll('.product-single__meta .variant-input input[type="radio"]'));
    var groups = {};
    radios.forEach(function(r){
      var name = r.getAttribute('name') || ''; if (!name) return;
      (groups[name] = groups[name] || []).push(r);
    });
    return Object.keys(groups).map(function(name){
      var n = name.toLowerCase();
      var kind = (/color|colour|metal|finish/.test(n)) ? 'metal' : (/carat|weight|size/.test(n)) ? 'pill' : 'skip';
      return { name: name, kind: kind, inputs: groups[name] };
    }).filter(function(g){ return g.inputs.length > 1 && g.kind !== 'skip'; });
  }
  /* Jordan, on the first render: "dropdown selector, not beside each other" — one compact
     <select> per option, not chips and pills fighting the price for the width. */
  function buildPickers(host){
    var groups = pickerGroups();
    if (!groups.length) return false;
    var sig = groups.map(function(g){ return g.name + ':' + g.inputs.map(function(i){ return i.value + (i.checked ? '*' : '') + (i.disabled ? '!' : ''); }).join('|'); }).join(';');
    if (host.getAttribute('data-st-sig') === sig) return true;   /* nothing changed; keep the DOM (and its focus) */
    host.setAttribute('data-st-sig', sig);
    host.textContent = '';
    host.classList.add('mlmt-sticky__pick');
    groups.forEach(function(g){
      var sel = document.createElement('select');
      sel.className = 'mlmt-sticky__sel mlmt-sticky__sel--' + g.kind;
      sel.setAttribute('aria-label', g.name);
      var chosen = '';
      g.inputs.forEach(function(inp){
        var o = document.createElement('option');
        o.value = inp.id || inp.value;
        o.textContent = inp.value.replace(/[\u2B50\uFE0F]/g, '').trim();
        o.disabled = !!inp.disabled;
        o.selected = !!inp.checked;
        if (inp.checked) chosen = inp.value;
        sel.appendChild(o);
      });
      if (g.kind === 'metal'){
        /* the breaker's row: a swatch dot in the metal's colour sits inside the select
           (snippets/mlmt-qty-breaker .mlmt-qb__selwrap / .mlmt-qb__mdot — same look, own class) */
        var wrap = document.createElement('span');
        wrap.className = 'mlmt-sticky__selwrap';
        var dot = document.createElement('span');
        dot.className = 'mlmt-sticky__mdot';
        dot.setAttribute('aria-hidden', 'true');
        dot.style.background = metalTone(chosen);
        wrap.appendChild(dot);
        wrap.appendChild(sel);
        host.appendChild(wrap);
        return;
      }
      host.appendChild(sel);
    });
    return true;
  }
  document.addEventListener('change', function(e){
    var sel = e.target && e.target.closest && e.target.closest('[data-mlmt-sticky] .mlmt-sticky__sel');
    if (!sel) return;
    var inp = document.getElementById(sel.value); if (!inp) return;
    var lab = document.querySelector('label[for="' + (window.CSS && CSS.escape ? CSS.escape(sel.value) : sel.value) + '"]') || inp.closest('label');
    if (lab) lab.click(); else { inp.checked = true; inp.dispatchEvent(new Event('change', { bubbles: true })); }
  });

  document.addEventListener('click', function(e){
    var st = e.target && e.target.closest && e.target.closest('[data-mlmt-sticky] [data-st-add]');
    if (!st || st.disabled) return;
    var b = liveTarget();
    if (b && !b.disabled) b.click();
  });

  /* bind (or re-bind) the bar to the real button that is in the DOM now */
  function arm(){
    var bar = getBar(); if (!bar) return;
    target = realBtn();
    if (!target) return;
    bar.hidden = false;
    if (io) io.disconnect();
    /* 18 Sep 2026, Jordan: "this sticky bar shouldn't activate on load, only when it passes the
       native add to cart button it should show. We want people to scroll below to see the
       upsells and the quantity breaker for higher AOV." So: the bar shows only once the real
       button is ABOVE the viewport (scrolled past), never while it is still below the fold. */
    function show(passed){
      var bar = getBar(); if (!bar) return;
      var was = bar.hasAttribute('data-show');
      if (!passed) { bar.removeAttribute('data-show'); bar.setAttribute('aria-hidden','true'); }
      else         { bar.setAttribute('data-show',''); bar.setAttribute('aria-hidden','false'); if (!was) sync(); }
    }
    io = new IntersectionObserver(function(entries){
      var en = entries[0];
      show(!en.isIntersecting && en.boundingClientRect.top < 0);
    }, { rootMargin: '0px 0px -40px 0px' });
    io.observe(target);
    /* and a plain scroll check beside the observer — IO callbacks pause in a hidden tab and
       arrive late after a jump; the position is the truth either way */
    var ticking = false;
    function onScroll(){
      if (ticking) return; ticking = true;
      setTimeout(function(){ ticking = false; var t = liveTarget(); if (t) show(t.getBoundingClientRect().bottom < 0); }, 80);
    }
    if (!arm.scrollBound){ window.addEventListener('scroll', onScroll, { passive: true }); arm.scrollBound = true; }
    sync();
  }
  arm();
  if (!target) return;

  window.addEventListener('load', sync);
  setTimeout(sync, 600);
  setTimeout(sync, 1800);

  document.addEventListener('variant:change', function(){
    /* Motion's updateCartButton runs on this same event; the second pass
       catches whichever listener ran after us. The third (20 Sep 2026) lands after the
       breaker has repainted its thumbnail and the gallery has swapped its slides. */
    setTimeout(sync, 0);
    setTimeout(sync, 150);
    setTimeout(sync, 500);
  });
  /* 12 Sep 2026: a tier or a bundle row changing re-prices the bar. The
     breaker repaints on its own box-level listener first; we read after it.
     18 Sep 2026: and if the breaker in the DOM is not bound (the editor swapped
     the section), bind it before reading — a checked radio on a dead breaker
     is how the bar said 138 beside a tier that looked single. */
  document.addEventListener('change', function(e){
    if (e.target && e.target.closest && e.target.closest('[data-mlmt-qb]')){
      if (window.mlmtQbBind) window.mlmtQbBind();
      setTimeout(sync, 80);
    }
  });
  document.addEventListener('shopify:section:load', function(){ setTimeout(arm, 0); });
})();

/* ── the Essential Upsell app block: price colour (18 Sep 2026) ──
   Jordan: "the color of the prices in the upsell is gold, while in the bundle breaker it is
   brown — fix to the same brown colour to be in line." The app paints its prices from its own
   settings, through hashed atomic classes that change with every app release, so there is no
   selector to override. This matches on the COLOUR instead: any text node inside the app block
   painted the app's gold (#d4af37) is repainted with the theme's ink, and the observer keeps it
   that way when the app re-renders on a variant change. Struck compare-at prices are left. */
(function(){
  var GOLD = 'rgb(212, 175, 55)';
  var ink = function(){ return (getComputedStyle(document.documentElement).getPropertyValue('--mlmtInk') || '#2c2c2c').trim(); };
  function paint(root){
    [].forEach.call(root.querySelectorAll('*'), function(el){
      if (el.children.length) return;
      if (getComputedStyle(el).color === GOLD) el.style.color = ink();
    });
  }
  function arm(){
    var blocks = document.querySelectorAll('.shopify-app-block[id*="essential_upsell"]');
    if (!blocks.length) return false;
    [].forEach.call(blocks, function(b){
      paint(b);
      new MutationObserver(function(){ paint(b); }).observe(b, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
    });
    return true;
  }
  if (!arm()){ var tries = 0; var t = setInterval(function(){ if (arm() || ++tries > 20) clearInterval(t); }, 500); }
  document.addEventListener('shopify:section:load', function(){ setTimeout(arm, 0); });
})();

/* ── block mlmt_cashback: the How-it-works dialog (18 Sep 2026) ── */
(function(){
  var dlg = document.querySelector('[data-cb-dialog]');
  if (!dlg) return;
  var last = null;
  function open(){ last = document.activeElement; dlg.hidden = false; document.documentElement.classList.add('mlmt-dlg-open'); var x = dlg.querySelector('[data-cb-close]'); if (x) x.focus(); }
  function close(){ dlg.hidden = true; document.documentElement.classList.remove('mlmt-dlg-open'); if (last && last.focus) last.focus(); }
  document.addEventListener('click', function(e){
    var t = e.target;
    if (t.closest && t.closest('[data-cb-how]')){ e.preventDefault(); open(); return; }
    if (!dlg.hidden && t.closest && (t.closest('[data-cb-close]') || (t === dlg))) close();
  });
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && !dlg.hidden) close(); });
})();

/* ── block mlmt_compare_btn ── */
(function(){
  var dlg = document.querySelector('[data-cmp-dialog]');
  if (!dlg) return;
  var body = dlg.querySelector('[data-cmp-body]');

  function panel(){
    return document.querySelector('.mlmt-compare, [data-mlmt-compare], #mlmt-compare');
  }

  function open(){
    var src = panel();
    body.innerHTML = '';
    if (src) body.appendChild(src.cloneNode(true));
    else body.innerHTML = '<p style="font-family:var(--fontBody);font-size:13.5px;color:var(--mlmtInk2)">' +
      'Carat weight changes the width of the line and the size of each stone. Everything else — the metal, ' +
      'the setting and the clasp — is identical across the options.</p>';
    dlg.hidden = false;
    document.documentElement.style.overflow = 'hidden';
  }
  function close(){ dlg.hidden = true; document.documentElement.style.overflow = ''; }

  dlg.querySelector('[data-cmp-close]').addEventListener('click', close);
  dlg.addEventListener('click', function(e){ if (e.target === dlg) close(); });
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && !dlg.hidden) close(); });


  /* 15 Sep 2026: the compare SLIDE-OVER (snippets/mlmt-pdp-drawers-chrome,
     [data-dr="cmp"]) owns [data-cmp-open] whenever it is on the page — it
     carries the real per-option rows, while this dialog only ever found its
     stock paragraph. Both listeners fired on one click and left two
     scroll-locked overlays open; this one now steps back when the drawer
     exists. */
  document.addEventListener('click', function(e){
    var b = e.target.closest && e.target.closest('[data-cmp-open]');
    if (!b) return;
    if (document.querySelector('[data-dr="cmp"]')) return;
    e.preventDefault(); open();
  });
})();

/* ── block mlmt_currency_code ── */
(function(){
  var CODE = (window.Shopify && Shopify.currency && Shopify.currency.active) || '';
  if (!CODE) return;

  function mark(el){
    if (!el || el.dataset.mlmtCur) return;


    if (el.closest('.price-original, .igComparePrice, s, del, .cart__original-price')) return;
    if (/line-through/.test(getComputedStyle(el).textDecorationLine || '')) return;

    var t = (el.textContent || '').trim();
    if (!t || t.indexOf(CODE) !== -1) { el.dataset.mlmtCur = '1'; return; }
    if (/[A-Z]{3}\s*$/.test(t)) { el.dataset.mlmtCur = '1'; return; }
    var s = document.createElement('span');
    s.className = 'mlmt-cur';
    s.textContent = CODE;
    el.appendChild(s);
    el.dataset.mlmtCur = '1';
  }

  function run(){
    var sel = '.product-single__meta .price-sale, .product-single__meta [data-product-price],' +
              '.product-single__meta .product__price, .product-single__meta .product-single__price';

    [].forEach.call(document.querySelectorAll('.price-original .mlmt-cur, .igComparePrice .mlmt-cur, s .mlmt-cur, del .mlmt-cur'),
                    function(n){ n.remove(); });
    [].forEach.call(document.querySelectorAll(sel), mark);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();


  var t;
  new MutationObserver(function(){
    clearTimeout(t);
    t = setTimeout(function(){
      [].forEach.call(document.querySelectorAll('[data-mlmt-cur]'), function(el){
        if ((el.textContent || '').indexOf(CODE) === -1) delete el.dataset.mlmtCur;
      });
      run();
    }, 150);
  }).observe(document.body, { childList:true, subtree:true, characterData:true });
})();

/* ── snippets/mlmt-gemstone-picker ── */
(function(){
  /* Hovering a swatch previews its name in the header, so a shopper can
     read the stone before committing to a page load. */
  var box = document.querySelector('[data-mlmt-stones]');
  if (!box) return;
  var out = box.querySelector('[data-stone-name]');
  if (!out) return;
  var settled = out.textContent.trim();
  box.addEventListener('mouseover', function(e){
    var a = e.target.closest('.mlmt-stones__sw');
    if (a) out.textContent = a.getAttribute('data-stone') || settled;
  });
  box.addEventListener('mouseleave', function(){ out.textContent = settled; });
})();

/* ── block mlmt_angara_panels · Explore colors arrows ──
   18 Sep 2026, Jordan: "make at least 4 colors show, closer to each other, and keep the arrows
   so we can see we can click to scroll." Delegated on the document so it survives the theme
   editor re-rendering the section; each press moves the rail three tiles, and the arrow at
   an end dims so the rail says where it is. */
(function(){
  if (window.__mlmtApRailBound) return; window.__mlmtApRailBound = true;
  function railOf(btn){
    var box = btn.closest('.mlmt-ap__box');
    return box && box.querySelector('[data-ap-rail]');
  }
  function paint(rail){
    var box = rail.closest('.mlmt-ap__box'); if (!box) return;
    var prev = box.querySelector('[data-ap-scroll="-1"]'), next = box.querySelector('[data-ap-scroll="1"]');
    var max = rail.scrollWidth - rail.clientWidth;
    if (prev) prev.disabled = rail.scrollLeft <= 10;   /* the snap parks the first tile at the 8px padding */
    if (next) next.disabled = max <= 2 || rail.scrollLeft >= max - 2;
  }
  document.addEventListener('click', function(e){
    var b = e.target.closest && e.target.closest('[data-ap-scroll]'); if (!b) return;
    var rail = railOf(b); if (!rail) return;
    var tile = rail.querySelector('.mlmt-ap__gem');
    var step = tile ? (tile.getBoundingClientRect().width + 4) * 3 : rail.clientWidth * 0.8;
    rail.scrollBy({ left: step * parseInt(b.getAttribute('data-ap-scroll'), 10), behavior: 'smooth' });
    setTimeout(function(){ paint(rail); }, 450);
  });
  document.addEventListener('scroll', function(e){
    if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-ap-rail')) paint(e.target);
  }, true);
  function all(){ [].forEach.call(document.querySelectorAll('[data-ap-rail]'), paint); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  window.addEventListener('load', all);
  window.addEventListener('resize', all);
  document.addEventListener('shopify:section:load', function(){ setTimeout(all, 50); });
})();


/* ── snippets/mlmt-tp-mini — slides one card every five seconds, wraps; arrows + position bar (19 Sep 2026) ──
   The track is a real scroller (snap, hand-scrollable); the timer scrolls it by one card.
   Jordan: "when they press the arrow one time, the auto loading stops, so they can quietly
   read" — an arrow press (or a hand scroll) ends the auto-advance for good. Hover pauses;
   reduced motion never starts it; the theme editor's section re-render re-arms it. */
(function(){
  if (window.__mlmtTpMiniBound) return; window.__mlmtTpMiniBound = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function step(track){
    var card = track.querySelector('[data-tp-mini-item]'); if (!card) return 0;
    var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 8;
    return card.getBoundingClientRect().width + gap;
  }
  function paint(root){
    var track = root.querySelector('[data-tp-mini-track]'), fill = root.querySelector('[data-tp-mini-fill]');
    if (!track || !fill) return;
    var max = track.scrollWidth - track.clientWidth;
    var seen = max > 0 ? (track.clientWidth + track.scrollLeft) / track.scrollWidth : 1;
    fill.style.width = (Math.max(0.04, Math.min(1, seen)) * 100).toFixed(1) + '%';
  }
  function move(root, dir){
    var track = root.querySelector('[data-tp-mini-track]'); if (!track) return;
    var max = track.scrollWidth - track.clientWidth, st = step(track);
    if (dir > 0 && track.scrollLeft >= max - 2) track.scrollTo({ left: 0, behavior: 'smooth' });
    else if (dir < 0 && track.scrollLeft <= 2) track.scrollTo({ left: max, behavior: 'smooth' });
    else track.scrollBy({ left: st * dir, behavior: 'smooth' });
  }
  /* "Expand review" shows only on a card whose quote is actually clamped; a click on the
     card (or the link) opens it in full, stops the auto-advance, and reads "Show less". */
  function measure(root){
    [].forEach.call(root.querySelectorAll('[data-tp-mini-item]'), function(card){
      var q = card.querySelector('[data-tp-mini-q]'), more = card.querySelector('[data-tp-mini-more]');
      if (!q || !more || card.classList.contains('is-open')) return;
      var t = card.querySelector('.mlmt-tpm__t');
      var clamped = q.scrollHeight > q.clientHeight + 1 || (t && t.scrollWidth > t.clientWidth + 1);
      more.hidden = !clamped;
    });
  }
  function toggle(card){
    var open = !card.classList.contains('is-open');
    card.classList.toggle('is-open', open);
    var more = card.querySelector('[data-tp-mini-more]');
    /* 19 Sep 2026, Jordan: "also have a button 'minimise review' when it's expanded so you can close it" */
    if (more){ more.hidden = false; more.textContent = open ? 'Minimise review' : 'Expand review'; more.setAttribute('aria-expanded', open ? 'true' : 'false'); }
    var root = card.closest('[data-tp-mini]'); if (root){ root.__tpStop = true; if (!open) measure(root); }
  }
  function arm(root){
    if (root.__tpArmed) return; root.__tpArmed = true;
    var track = root.querySelector('[data-tp-mini-track]'); if (!track) return;
    measure(root);
    root.addEventListener('mouseenter', function(){ root.__tpHold = true; });
    root.addEventListener('mouseleave', function(){ root.__tpHold = false; });
    track.addEventListener('touchstart', function(){ root.__tpStop = true; }, { passive: true });
    var t; track.addEventListener('scroll', function(){ clearTimeout(t); t = setTimeout(function(){ paint(root); }, 80); }, { passive: true });
    paint(root);
    if (reduce) return;
    root.__tpTimer = setInterval(function(){
      if (root.__tpStop || root.__tpHold || document.visibilityState === 'hidden') return;
      move(root, 1);
    }, 5000);
  }
  document.addEventListener('click', function(e){
    var b = e.target.closest && e.target.closest('[data-tp-mini-prev],[data-tp-mini-next]');
    if (b){
      var root = b.closest('[data-tp-mini]'); if (!root) return;
      root.__tpStop = true;
      move(root, b.hasAttribute('data-tp-mini-next') ? 1 : -1);
      return;
    }
    var card = e.target.closest && e.target.closest('[data-tp-mini-item]');
    if (card) toggle(card);
  });
  function all(){ [].forEach.call(document.querySelectorAll('[data-tp-mini]'), arm); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  window.addEventListener('load', all);
  window.addEventListener('resize', function(){ [].forEach.call(document.querySelectorAll('[data-tp-mini]'), function(r){ paint(r); measure(r); }); });
  window.addEventListener('load', function(){ [].forEach.call(document.querySelectorAll('[data-tp-mini]'), measure); });
  document.addEventListener('shopify:section:load', function(){ setTimeout(all, 50); });
})();


/* ── the SAVE / FREE Shipping badges beside the price (19 Sep 2026) ──
   Jordan: "when I press a separate variant the 'save' and 'free shipping' disappear."
   Motion rewrites [data-product-price]'s innerHTML on variant:change; the badges now live
   beside it (snippets/product-template) and this keeps the SAVE amount the VARIANT's. */
(function(){
  if (window.__mlmtPbadgesBound) return; window.__mlmtPbadgesBound = true;
  function fmt(cents){
    var out = '';
    try { if (window.theme && theme.Currency && theme.Currency.formatMoney) out = theme.Currency.formatMoney(cents, theme.settings.moneyFormat); } catch (e) {}
    if (!out) out = '$' + (cents / 100).toFixed(2);
    return String(out).replace(/([.,])00(?=\s|$|<)/, '').replace(/<[^>]*>/g, '').trim();
  }
  document.addEventListener('variant:change', function(e){
    var v = e && e.detail && e.detail.variant; if (!v) return;
    [].forEach.call(document.querySelectorAll('[data-mlmt-pbadges]'), function(host){
      var save = host.querySelector('.igSavingsPrice'), amt = host.querySelector('[data-mlmt-save-amt]');
      var diff = (parseInt(v.compare_at_price, 10) || 0) - (parseInt(v.price, 10) || 0);
      if (save){ save.hidden = !(diff > 0); if (diff > 0 && amt) amt.textContent = fmt(diff); }
    });
  });
})();
